module.exports = __webpack_public_path__ + "img/rating-video-background.e6ca9a91.png";